import React from 'react';
import PropTypes from 'prop-types';
import { classWithModifiers } from '~/react/componentHelper';
import { defineMessages, FormattedMessage } from 'react-intl';

defineMessages({
  GO_TO_HOME: {
    id: 'GO_TO_HOME',
    description: 'Text for the back to home button',
    defaultMessage: 'Go To Homepage',
  },
});
const { setLinkCetDataVars } = require('~/server/utils/cetTrackingHelper');

const setCetDataAttributes = (cetDataVars, cetSubUnitName, subUnitPosition) => {
  const specificCetDataVars = {
    'data-vars-subunit-name': cetSubUnitName,
    'data-vars-subunit-type': 'component',
    'data-vars-position-in-subunit': subUnitPosition,
  };

  const finalCetDataVars = specificCetDataVars
    ? Object.assign(cetDataVars, specificCetDataVars)
    : {};
  return finalCetDataVars;
};

const BackToHome = ({
  options, homeUrl, modifiers, position,
}) => {
  const {
    cetUnit, cetSubUnit, entryId = '', positionInSubUnitCounts = {}, positionInUnitCounts = {}, isAmp = false, cetDataVars = null,
  } = options;

  // CET tracking
  let backToHomePositionInUnit = null;
  let backToHomePositionInSubUnit = null;
  let cetAttributes = cetDataVars;
  if (!cetAttributes) {
    if (positionInUnitCounts && positionInUnitCounts && Object.keys(positionInUnitCounts).length > 0 && positionInUnitCounts[cetUnit] && positionInSubUnitCounts && Object.keys(positionInSubUnitCounts).length > 0 && positionInSubUnitCounts[cetSubUnit]) {
      backToHomePositionInUnit = positionInUnitCounts[cetUnit].count;
      positionInUnitCounts[cetUnit].count += 1;
      backToHomePositionInSubUnit = positionInSubUnitCounts[cetSubUnit].count;
      positionInSubUnitCounts[cetSubUnit].count += 1;
    }
    const cetLinkDataVars = setLinkCetDataVars(cetUnit, homeUrl, 'Go To Homepage', 'button', entryId);
    cetAttributes = setCetDataAttributes(cetLinkDataVars, cetSubUnit, backToHomePositionInSubUnit);
    if (isAmp) {
      cetAttributes['data-vars-position-in-unit'] = backToHomePositionInUnit;
    }
  }

  let styleClass = '';
  if (position === 'footer') {
    styleClass = ' accent-button';
  }

  return (
    <div className="back-to-home js-cet-subunit">
      <div className={`${classWithModifiers('back-to-home__container', modifiers)} js-entry-link cet-internal-link${styleClass}`}>
        <a
          className="back-to-home__button"
          aria-label="Go to HuffPost Homepage"
          role="button"
          href="/"
          {...cetAttributes}
        >
          <span className="arrow-left" />
          {' '}
          <FormattedMessage id="GO_TO_HOME" />
        </a>
      </div>
    </div>
  );
};

BackToHome.propTypes = {
  homeUrl: PropTypes.string.isRequired,
  position: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.shape({
    isAmp: PropTypes.bool,
    entryId: PropTypes.string,
    position: PropTypes.string,
    positionInUnitCounts: PropTypes.shape({}),
    positionInSubUnitCounts: PropTypes.shape({}),
    cetUnit: PropTypes.string,
    cetSubUnit: PropTypes.string,
    cetDataVars: PropTypes.shape({}),
  }),
};

BackToHome.defaultProps = {
  position: '',
  modifiers: [],
  options: {
    cetUnit: 'buzz_body',
    cetSubUnit: 'article_body',
    cetDataVars: null,
    options: {},
  },
};

export default BackToHome;
